import { render } from "./SidebarPrincipal.vue?vue&type=template&id=4a2c5c81&scoped=true"
import script from "./SidebarPrincipal.vue?vue&type=script&lang=js"
export * from "./SidebarPrincipal.vue?vue&type=script&lang=js"

import "./SidebarPrincipal.vue?vue&type=style&index=0&id=4a2c5c81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2c5c81"]])

export default __exports__